import { Injectable } from '@angular/core';
import { Logger } from '../logger/logger.service';

const log = new Logger('LS');
const storage = sessionStorage || localStorage;

@Injectable({
  providedIn: 'root',
})
export class PersistenceService {
  constructor() {}

  set(key: string, data: unknown): void {
    try {
      storage.setItem(key, JSON.stringify(data));
    } catch (error) {
      log.debug('Error saving to LS: ', error);
    }
  }

  get(key: string): any | null {
    try {
      const lsItem = storage.getItem(key);
      return lsItem ? JSON.parse(lsItem) : null;
    } catch (error) {
      log.debug('Error retrieving data from LS: ', error);
      return null;
    }
  }

  delete(key: string) {
    try {
      storage.removeItem(key);
    } catch (error) {
      log.debug('Error deleting from LS: ', error);
    }
  }
}
